export default __webpack_public_path__ + "static/sedan-a51c28a3990e104acdf5b89567f0481e.png";